import { ConfirmDialog, Typography } from '@occc/ui-design-system';
import { RetailerNetworkUserFragment } from '@occc/graphql';

type RetailerNetworkRemoveUserDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  user: RetailerNetworkUserFragment | null;
  retailerNetworkName: string;
};

export const RetailerNetworkRemoveUserDialog = ({
  open,
  onClose,
  onConfirm,
  user,
  retailerNetworkName,
}: RetailerNetworkRemoveUserDialogProps) => {
  return (
    <ConfirmDialog
      dialogTitle='Remove User from the Retailer Network'
      onClose={onClose}
      open={open}
      maxWidth='xs'
      confirmButtonText='Remove'
      confirmButtonProps={{
        onClick: onConfirm,
        disabled: false,
        color: 'error',
      }}
    >
      <Typography>
        {`Are you sure you would like to remove ${
          user?.name || 'this user'
        } from the ${retailerNetworkName}. This will remove their access to Retailer Connect.`}
      </Typography>
    </ConfirmDialog>
  );
};
